import * as React from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { useQuery } from '../hooks/useQuery';
import { useForm, Controller } from 'react-hook-form';
import { FormControl } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import TextField from '@mui/material/TextField';
import InputMask from 'react-input-mask';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { useSearchParams, useNavigate } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import { useSnackbar } from '../hooks/useSnackbar';
import SaveIcon from '@mui/icons-material/Save';
import { useAuth } from '../hooks/useAuth';
import { cryptedParam, decryptData, decryptedParam } from '../utils';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Tooltip from '@mui/material/Tooltip';

export const Step2Cadastro = ({
  activeStep,
  setActiveStep,
  fornecedor,
  setFornecedor,
}) => {
  const {
    handleSubmit,
    control,
    setValue,
    reset,
    formState: { errors },
  } = useForm();
  const {
    cadastroStep2,
    listarMunicipios,
    listarEstados,
    showCadastroFornecedor,
    listarPaises,
    getCep,
  } = useQuery();
  const { user } = useAuth();
  const [estados, setEstados] = React.useState([]);
  const [municipios, setMunicipios] = React.useState([]);
  const [paises, setPaises] = React.useState([]);
  const [pais, setPais] = React.useState();
  const [municipio, setMunicipio] = React.useState();
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = React.useState(false);
  const [isRascunho, setIsRascunho] = React.useState(false);
  const { isUsuarioSebrae, isPrototocoloVencido } = useAuth();
  const [checkStep2, setCheckStep2] = React.useState(false);
  const snackbar = useSnackbar();
  const navigate = useNavigate();

  React.useEffect(() => {
    getEstados();
    getPaises();
    if (searchParams.get('fornecedor_id')) {
      const fornecedor_id = decryptData(searchParams.get('fornecedor_id'));
      if (!fornecedor_id) {
        return navigate('/dashboard/listar-cadastros');
      }
      preencherFormulario(fornecedor_id);
    }
  }, []);

  const preencherFormulario = async (id) => {
    try {
      setLoading(true);
      const result = await showCadastroFornecedor(id);

      if (result && result.data && result.data.data) {
        setFornecedor(result.data.data);
        setValue('estado', result.data.data.estado_id);
        getMunicipios(
          result.data.data.estado_id,
          result.data.data.municipio_id,
        );
        setValue('cep', result.data.data.cep);
        // setValue("pais", result.data.data.pais);
        setValue('endereco', result.data.data.endereco);
        setValue('bairro', result.data.data.bairro);
        setValue('complemento', result.data.data.complemento);
        setValue('numero', result.data.data.numero);
      }
      setLoading(false);
    } catch (error) {
      navigate('/dashboard/listar-cadastros');
    }
  };

  const onSubmit = (data) => {
    fornecedor.pais = data.pais.nome_pt;
    fornecedor.bairro = data.bairro;
    fornecedor.endereco = data.endereco;
    fornecedor.numero = data.numero;
    fornecedor.cep = data.cep;
    fornecedor.complemento = data.complemento;
    data = { ...data, ...fornecedor };
    data.cidade = data.cidade.codigo_municipio;

    cadastrarFornecedor(data);
  };

  const getEstados = async () => {
    let result = await listarEstados();
    setEstados(result.data.data);
  };

  const getPaises = async () => {
    let result = await listarPaises();
    setPaises(result.data.data);

    const paisEncontrado = result.data.data.filter(
      (pais) => 'Brasil' === pais.nome_pt,
    );

    if (paisEncontrado.length > 0) {
      setPais(paisEncontrado[0]);
      setValue('pais', paisEncontrado[0]);
    }

    if (fornecedor !== null) {
      const paisEncontrado = result.data.data.filter(
        (pais) => fornecedor.pais === pais.nome_pt,
      );

      if (paisEncontrado.length > 0) {
        setPais(paisEncontrado[0]);
        setValue('pais', paisEncontrado[0]);
      }
    }
  };

  const getMunicipios = async (
    estado_id,
    municipio_id = null,
    cidade = null,
  ) => {
    let result = await listarMunicipios(estado_id);
    setMunicipios(result && result.data && result.data.data);

    if (fornecedor !== null) {
      let municipioEncontrado = null;
      if (cidade !== null) {
        municipioEncontrado = result.data.data.filter(
          (mun) => cidade.toUpperCase() === mun.nome_municipio.toUpperCase(),
        );
      } else {
        if (municipioEncontrado === null) {
          municipioEncontrado = result.data.data.filter(
            (mun) => municipio_id === mun.codigo_municipio,
          );
        }
      }

      if (municipioEncontrado.length > 0) {
        setMunicipio(municipioEncontrado[0]);
        setValue('cidade', municipioEncontrado[0]);
      } else {
        setValue('cidade', null);
      }
    }
  };

  const onChangeEstado = (value) => {
    const estado = estados.find((estado) => estado.id === value);
    if (estado) {
      getMunicipios(estado.id);
    }
  };

  const cadastrarFornecedor = async (data) => {
    const result = await cadastroStep2(data);
    if (result && result.data && result.data.data) {
      setFornecedor(result.data.data);
      if (isRascunho) {
        if (isUsuarioSebrae) {
          navigate('/dashboard/listar-cadastros');
        } else {
          if (result.data.data.cnpj == null) {
            navigate(
              `/dashboard/listar-cadastros?fornecedor=${result.data.data.cnpj}`,
              { replace: true },
            );
          } else {
            navigate(
              `/dashboard/listar-cadastros?fornecedor=${result.data.data.cpf}`,
              { replace: true },
            );
          }
        }
        snackbar.showSnackbar('Rascunho salvo com sucesso.');
      } else {
        setActiveStep(activeStep + 1);
      }
    }
  };

  const onChangeCep = async (value) => {
    if (value.length == 8) {
      const result = await getCep(value);

      setValue('endereco', result.data.data.address.street);
      setValue('bairro', result.data.data.address.neighborhood);
      const estadoEcontrado = estados.find(
        (estado) => result.data.data.address.state === estado.uf,
      );

      onChangeEstado(estadoEcontrado.id);
      setValue('estado', estadoEcontrado.id);

      getMunicipios(estadoEcontrado.id, null, result.data.data.address.city);
      const paisEncontrado = paises.filter((pais) => 'Brasil' === pais.nome_pt);

      if (paisEncontrado.length > 0) {
        setPais(paisEncontrado[0]);
        setValue('pais', paisEncontrado[0]);
      }
    }
  };

  const onErrors = () => {};

  return (
    <form onSubmit={handleSubmit(onSubmit, onErrors)}>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress style={{ marginTop: 60 }} />
        </Box>
      ) : (
        <Grid container spacing={2} padding={2}>
          <Grid container sm={12} item>
            <p style={{ fontSize: 20, width: '100%', margin: 0 }}>
              <b>Cadastrar</b>
            </p>
            <p style={{ fontSize: 16, width: '100%' }}>
              Por favor, informe seus dados de endereço
            </p>
          </Grid>

          <Grid container sm={12} item>
            <p style={{ fontSize: 16 }}>
              <b>Endereço</b>
            </p>
          </Grid>
          <Grid container sm={6} item>
            <label style={{ color: '#707070' }}>CEP:</label>
            <Controller
              rules={{
                required: 'Campo é obrigatório',
              }}
              name="cep"
              control={control}
              render={({
                field: { onChange, value, onBlur },
                fieldState: { error },
              }) => (
                <InputMask
                  style={{ marginTop: '5px' }}
                  mask="99.999-999"
                  maskChar={'_'}
                  value={value}
                  onBlur={onBlur}
                  onChange={(val) => {
                    onChange(val);
                    onChangeCep(val.target.value.replace(/\D/g, ''));
                  }}
                >
                  {(inputProps) => (
                    <TextField
                      margin="normal"
                      error={error}
                      helperText={error && error.message}
                      fullWidth
                      {...inputProps}
                      id="cep"
                      placeholder="Digite o CEP"
                    />
                  )}
                </InputMask>
              )}
            />
          </Grid>
          <Grid container sm={6} item>
            <label style={{ color: '#707070' }}>País:</label>
            <Controller
              name="pais"
              id="pais"
              rules={{
                required: 'Campo é obrigatório',
              }}
              defaultValue={null}
              control={control}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <Autocomplete
                  options={paises}
                  value={value}
                  getOptionLabel={(option) => `${option.nome_pt}`}
                  onChange={(event, newValue) => {
                    onChange(newValue);
                    setPais(newValue);
                  }}
                  fullWidth
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={error}
                      helperText={error && error.message}
                    />
                  )}
                />
              )}
            />
          </Grid>
          <Grid container sm={6} item>
            <label style={{ color: '#707070' }}>Estado:</label>
            <Controller
              rules={{
                required: 'Campo é obrigatório',
              }}
              name="estado"
              id="estado"
              control={control}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <Select
                  value={value}
                  style={{ height: 40 }}
                  error={error}
                  onChange={(e) => {
                    onChange(e);
                    onChangeEstado(e.target.value);
                  }}
                  fullWidth
                >
                  <MenuItem disabled value={0}>
                    Selecione o estado
                  </MenuItem>
                  {estados.map((estado) => {
                    return (
                      <MenuItem key={estado.uf} value={estado.id}>
                        {estado.nome}
                      </MenuItem>
                    );
                  })}
                </Select>
              )}
            />
          </Grid>
          <Grid container sm={6} item>
            <label style={{ color: '#707070' }}>Cidade:</label>
            <Controller
              name="cidade"
              id="cidade"
              rules={{
                required: 'Campo é obrigatório',
              }}
              defaultValue={null}
              control={control}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <Autocomplete
                  options={municipios}
                  value={value}
                  getOptionLabel={(option) => `${option.nome_municipio}`}
                  onChange={(event, newValue) => {
                    onChange(newValue);
                    setMunicipio(newValue);
                  }}
                  fullWidth
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={error}
                      helperText={error && error.message}
                    />
                  )}
                />
              )}
            />
          </Grid>
          <Grid container sm={6} item>
            <label style={{ color: '#707070' }}>Endereço:</label>
            <Controller
              name="endereco"
              control={control}
              rules={{
                required: 'Campo é obrigatório',
              }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <TextField
                  style={{ marginTop: '5px' }}
                  margin="normal"
                  value={value}
                  error={error}
                  helperText={error && error.message}
                  onChange={onChange}
                  fullWidth
                  placeholder="Digite o endereço"
                />
              )}
            />
          </Grid>
          <Grid container sm={6} item>
            <label style={{ color: '#707070' }}>Nº:</label>
            <Controller
              name="numero"
              control={control}
              rules={{
                required: 'Campo é obrigatório',
              }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <Tooltip
                  title="Caso não haja número no endereço, preencher com 000"
                  placement="top"
                >
                  <TextField
                    style={{ marginTop: '5px' }}
                    margin="normal"
                    type="number"
                    value={value}
                    error={error}
                    helperText={error && error.message}
                    onChange={onChange}
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                    }}
                    fullWidth
                    placeholder="Digite o numero"
                  />
                </Tooltip>
              )}
            />
          </Grid>
          <Grid container sm={6} item>
            <label style={{ color: '#707070' }}>Bairro:</label>
            <Controller
              name="bairro"
              rules={{
                required: 'Campo é obrigatório',
              }}
              control={control}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <TextField
                  style={{ marginTop: '5px' }}
                  margin="normal"
                  value={value}
                  error={error}
                  helperText={error && error.message}
                  onChange={onChange}
                  fullWidth
                  placeholder="Digite o bairro"
                />
              )}
            />
          </Grid>

          <Grid container sm={6} item>
            <label style={{ color: '#707070' }}>Complemento:</label>
            <Controller
              name="complemento"
              control={control}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <TextField
                  style={{ marginTop: '5px' }}
                  margin="normal"
                  value={value}
                  error={error}
                  helperText={error && error.message}
                  onChange={onChange}
                  fullWidth
                  placeholder="Digite o complemento"
                />
              )}
            />
          </Grid>
        </Grid>
      )}
      {loading ? null : (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            pt: 2,
            justifyContent: 'space-between',
            marginBottom: '-50px',
          }}
        >
          <Button
            type="button"
            variant="text"
            color="primary"
            style={{ marginRight: '0.5rem' }}
            onClick={() => {
              setActiveStep(activeStep - 1);
            }}
          >
            <ArrowBackIosIcon color="primary" />
            Voltar
          </Button>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              pt: 2,
              justifyContent: 'flex-end',
            }}
          >
            <Button
              type="submit"
              variant="contained"
              color="warning"
              style={{ marginRight: '0.5rem' }}
              onClick={() => {
                setIsRascunho(true);
              }}
            >
              Salvar como rascunho
              <SaveIcon />
            </Button>
            <Button
              type="submit"
              variant="contained"
              onClick={() => {
                setIsRascunho(false);
              }}
            >
              Próximo
            </Button>
          </Box>
        </Box>
      )}
    </form>
  );
};
